import { useState } from 'react';

type Tab = 'omron' | 'loxone';

const omronProjects = [
  {
    id: 1,
    title: 'Mehrachsige Montageanlage – Automotive',
    industry: 'Automobilindustrie',
    description:
      'Vollautomatische Montageanlage mit 6 Achsen für die Kleinteilemontage in der Automobilzulieferung. OMRON NJ501 als Master-Controller, EtherCAT-Antriebe für synchronisierte Bewegungsabläufe, Sysmac Studio mit strukturiertem Code nach IEC 61131-3.',
    tags: ['NJ501', 'EtherCAT', '6-Achs-Motion', 'Sysmac Studio'],
    stats: [
      { label: 'Taktzeit', value: '< 4 s' },
      { label: 'Achsen', value: '6' },
      { label: 'Verfügbarkeit', value: '99,5 %' },
    ],
    img: 'https://readdy.ai/api/search-image?query=industrial%20robotic%20assembly%20line%20automotive%20manufacturing%20with%20OMRON%20PLC%20control%20cabinet%20NJ%20series%20mounted%20in%20clean%20white%20electrical%20panel%2C%20multiple%20servo%20drives%20and%20EtherCAT%20modules%2C%20professional%20industrial%20automation%20environment%20with%20precise%20cable%20management%2C%20grey%20and%20white%20tones&width=720&height=480&seq=omron-ref-automotive-01&orientation=landscape',
  },
  {
    id: 2,
    title: 'Prüfstand mit Safety-Integration',
    industry: 'Maschinenbau',
    description:
      'Elektrischer Prüfstand für Elektromotoren mit integrierter Sicherheitstechnik nach EN ISO 13849 PLd. OMRON NX102 mit NX Safety CPU, Not-Halt-Kreise, Schutztürüberwachung und vollständige Sicherheitsdokumentation.',
    tags: ['NX102', 'NX Safety CPU', 'PLd', 'EN ISO 13849'],
    stats: [
      { label: 'Safety Level', value: 'PLd' },
      { label: 'Prüfkanäle', value: '12' },
      { label: 'Inbetriebnahme', value: '3 Wochen' },
    ],
    img: 'https://readdy.ai/api/search-image?query=industrial%20test%20bench%20for%20electric%20motors%20with%20safety%20light%20curtains%20and%20emergency%20stop%20buttons%2C%20OMRON%20NX%20series%20safety%20PLC%20control%20panel%20with%20neat%20wiring%2C%20professional%20testing%20equipment%20in%20a%20clean%20manufacturing%20facility%2C%20grey%20metallic%20tones%20with%20red%20safety%20elements&width=720&height=480&seq=omron-ref-pruefstand-02&orientation=landscape',
  },
  {
    id: 3,
    title: 'Fördertechnik & Sortieranlage',
    industry: 'Intralogistik',
    description:
      'Automatisierte Sortieranlage mit Barcode-Scanner-Integration und OPC-UA-Anbindung an das übergeordnete WMS. OMRON NJ301 steuert 14 Frequenzumrichter über EtherNet/IP, Visualisierung über NA-Series HMI.',
    tags: ['NJ301', 'EtherNet/IP', 'OPC-UA', 'NA-Series HMI'],
    stats: [
      { label: 'Sortierpositionen', value: '24' },
      { label: 'Antriebe', value: '14' },
      { label: 'Durchsatz', value: '1.200 T/h' },
    ],
    img: 'https://readdy.ai/api/search-image?query=automated%20conveyor%20sorting%20system%20in%20a%20logistics%20warehouse%20with%20barcode%20scanners%20and%20diverters%2C%20industrial%20control%20cabinet%20with%20OMRON%20PLC%20and%20frequency%20inverters%2C%20clean%20intralogistics%20facility%20with%20modern%20conveyor%20belts%20and%20sorting%20equipment%2C%20neutral%20grey%20and%20blue%20tones&width=720&height=480&seq=omron-ref-foerder-03&orientation=landscape',
  },
];

const loxoneProjects = [
  {
    id: 1,
    title: 'Gewerbegebäude – Vollautomation',
    industry: 'Gewerbeimmobilie',
    description:
      'Komplette Gebäudeautomation eines 3-stöckigen Bürogebäudes mit 48 Räumen. Loxone Miniserver Go als Zentrale, KNX-Integration für Beleuchtung und Beschattung, HVAC-Steuerung, Zutrittskontrolle und Energiemonitoring über das Loxone Webinterface.',
    tags: ['Miniserver Go', 'KNX', 'HVAC', 'Energiemonitoring'],
    stats: [
      { label: 'Räume', value: '48' },
      { label: 'Datenpunkte', value: '320+' },
      { label: 'Energieeinsparung', value: '28 %' },
    ],
    img: 'https://readdy.ai/api/search-image?query=modern%20commercial%20office%20building%20interior%20with%20smart%20building%20automation%20touchscreen%20panel%20showing%20floor%20plan%20with%20lighting%20and%20climate%20zones%2C%20automated%20venetian%20blinds%20on%20large%20windows%2C%20clean%20minimalist%20office%20space%20with%20LED%20lighting%20and%20presence%20sensors%2C%20light%20grey%20and%20white%20interior%20design&width=720&height=480&seq=loxone-ref-gewerbe-01&orientation=landscape',
  },
  {
    id: 2,
    title: 'Produktionshalle – Licht & Sicherheit',
    industry: 'Industrie',
    description:
      'Loxone-Installation in einer 2.400 m² Produktionshalle: tageslichtabhängige DALI-Beleuchtungssteuerung, Bewegungsmelder-gesteuerte Zonenbeleuchtung, Alarmanlage mit Kameraintegration und Zutrittskontrolle für 6 Zugangspunkte.',
    tags: ['DALI', 'Alarmanlage', 'Zutrittskontrolle', 'Kameraintegration'],
    stats: [
      { label: 'Hallenfläche', value: '2.400 m²' },
      { label: 'Zugangspunkte', value: '6' },
      { label: 'Lichtszenen', value: '18' },
    ],
    img: 'https://readdy.ai/api/search-image?query=large%20industrial%20production%20hall%20with%20modern%20LED%20lighting%20automation%20system%2C%20smart%20building%20control%20with%20presence%20sensors%20and%20daylight-dependent%20lighting%20zones%2C%20clean%20manufacturing%20facility%20with%20automated%20lighting%20and%20security%20cameras%2C%20industrial%20grey%20and%20white%20tones%20with%20warm%20LED%20light&width=720&height=480&seq=loxone-ref-halle-02&orientation=landscape',
  },
  {
    id: 3,
    title: 'PV-Anlage & Wallbox-Management',
    industry: 'Energiemanagement',
    description:
      'Intelligentes Energiemanagementsystem mit Loxone: 48 kWp PV-Anlage, 30 kWh Batteriespeicher und 8 Wallboxen werden automatisch koordiniert. Eigenverbrauchsoptimierung, dynamisches Lastmanagement und Tarifsteuerung über MQTT-Schnittstelle.',
    tags: ['PV-Integration', 'Batteriespeicher', 'Wallbox', 'MQTT'],
    stats: [
      { label: 'PV-Leistung', value: '48 kWp' },
      { label: 'Wallboxen', value: '8' },
      { label: 'Eigenverbrauch', value: '74 %' },
    ],
    img: 'https://readdy.ai/api/search-image?query=modern%20commercial%20building%20rooftop%20with%20solar%20photovoltaic%20panels%20and%20electric%20vehicle%20charging%20stations%20in%20parking%20area%2C%20smart%20energy%20management%20system%20display%20showing%20power%20flow%20diagram%20with%20battery%20storage%20and%20EV%20charging%2C%20clean%20modern%20architecture%20with%20green%20energy%20focus%2C%20light%20grey%20and%20green%20tones&width=720&height=480&seq=loxone-ref-pv-03&orientation=landscape',
  },
];

const PartnerReferenzen = () => {
  const [activeTab, setActiveTab] = useState<Tab>('omron');
  const [activeProject, setActiveProject] = useState(0);

  const projects = activeTab === 'omron' ? omronProjects : loxoneProjects;
  const accentColor = activeTab === 'omron' ? '#CC0000' : '#6DAF3A';
  const accentBg = activeTab === 'omron' ? 'bg-red-50' : 'bg-green-50';
  const accentText = activeTab === 'omron' ? 'text-[#CC0000]' : 'text-[#6DAF3A]';
  const accentBorder = activeTab === 'omron' ? 'border-[#CC0000]' : 'border-[#6DAF3A]';
  const tagBg = activeTab === 'omron' ? 'bg-red-50 text-[#CC0000]' : 'bg-green-50 text-[#4a8a20]';

  const handleTabChange = (tab: Tab) => {
    setActiveTab(tab);
    setActiveProject(0);
  };

  const current = projects[activeProject];

  return (
    <section className="py-24 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-0.5 bg-[#DC2626]"></span>
              <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Referenzprojekte</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 leading-tight">
              Projekte aus der Praxis
            </h2>
            <p className="text-gray-500 text-base max-w-xl leading-relaxed">
              Konkrete Beispiele aus realisierten OMRON- und Loxone-Projekten – von der Planung bis zur Inbetriebnahme.
            </p>
          </div>

          {/* Tab Switcher */}
          <div className="flex items-center gap-1 bg-gray-100 rounded-full px-1 py-1 shrink-0 self-start md:self-auto">
            <button
              onClick={() => handleTabChange('omron')}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === 'omron'
                  ? 'bg-white text-[#CC0000] shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              OMRON
            </button>
            <button
              onClick={() => handleTabChange('loxone')}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === 'loxone'
                  ? 'bg-white text-[#6DAF3A] shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              Loxone
            </button>
          </div>
        </div>

        {/* Project Selector Tabs */}
        <div className="flex flex-wrap gap-3 mb-10">
          {projects.map((p, i) => (
            <button
              key={p.id}
              onClick={() => setActiveProject(i)}
              className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer border ${
                activeProject === i
                  ? `border-[${accentColor}] ${accentBg} ${accentText}`
                  : 'border-gray-200 text-gray-600 bg-white hover:border-gray-300'
              }`}
              style={activeProject === i ? { borderColor: accentColor, color: accentColor } : {}}
            >
              <span className="mr-2 font-bold">{String(i + 1).padStart(2, '0')}</span>
              {p.title}
            </button>
          ))}
        </div>

        {/* Main Project Card */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">

          {/* Left: Image */}
          <div className="relative w-full h-[360px] rounded-2xl overflow-hidden bg-gray-100">
            <img
              key={current.img}
              src={current.img}
              alt={current.title}
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
            {/* Industry Badge */}
            <div className="absolute top-4 left-4">
              <span
                className="inline-block text-white text-xs font-semibold px-3 py-1.5 rounded-full"
                style={{ backgroundColor: accentColor }}
              >
                {current.industry}
              </span>
            </div>
            {/* Nav Arrows */}
            <div className="absolute bottom-4 right-4 flex gap-2">
              <button
                onClick={() => setActiveProject((prev) => (prev - 1 + projects.length) % projects.length)}
                className="w-9 h-9 flex items-center justify-center bg-white/90 hover:bg-white rounded-full transition-colors cursor-pointer"
                aria-label="Vorheriges Projekt"
              >
                <i className="ri-arrow-left-line text-gray-700 text-sm"></i>
              </button>
              <button
                onClick={() => setActiveProject((prev) => (prev + 1) % projects.length)}
                className="w-9 h-9 flex items-center justify-center bg-white/90 hover:bg-white rounded-full transition-colors cursor-pointer"
                aria-label="Nächstes Projekt"
              >
                <i className="ri-arrow-right-line text-gray-700 text-sm"></i>
              </button>
            </div>
            {/* Counter */}
            <div className="absolute bottom-4 left-4 bg-black/50 text-white text-xs px-3 py-1.5 rounded-full">
              {activeProject + 1} / {projects.length}
            </div>
          </div>

          {/* Right: Content */}
          <div className="flex flex-col gap-6">

            {/* Title */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3 leading-tight">{current.title}</h3>
              <p className="text-gray-600 text-base leading-relaxed">{current.description}</p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4">
              {current.stats.map((s) => (
                <div
                  key={s.label}
                  className={`rounded-xl p-4 text-center border ${accentBg} ${accentBorder} border-opacity-30`}
                  style={{ borderColor: `${accentColor}30` }}
                >
                  <div className="font-bold text-xl text-gray-900 mb-0.5">{s.value}</div>
                  <div className="text-gray-500 text-xs">{s.label}</div>
                </div>
              ))}
            </div>

            {/* Tags */}
            <div className="flex flex-wrap gap-2">
              {current.tags.map((tag) => (
                <span
                  key={tag}
                  className={`text-xs font-medium px-3 py-1.5 rounded-full ${tagBg}`}
                >
                  {tag}
                </span>
              ))}
            </div>

            {/* Divider */}
            <div className="h-px bg-gray-100"></div>

            {/* CTA */}
            <div className="flex items-center gap-4">
              <a
                href="/anfrage"
                className="inline-flex items-center gap-2 text-white font-semibold px-5 py-3 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
                style={{ backgroundColor: accentColor }}
              >
                Ähnliches Projekt anfragen
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
              </a>
              <span className="text-gray-400 text-xs">Kostenlose Erstberatung</span>
            </div>
          </div>
        </div>

        {/* Bottom: All Projects Mini-Grid */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {projects.map((p, i) => (
            <button
              key={p.id}
              onClick={() => setActiveProject(i)}
              className={`text-left rounded-xl border p-5 transition-all duration-200 cursor-pointer group ${
                activeProject === i
                  ? 'border-gray-300 bg-gray-50'
                  : 'border-gray-100 bg-white hover:border-gray-200'
              }`}
            >
              <div className="flex items-start gap-3">
                <div
                  className="w-8 h-8 flex items-center justify-center rounded-lg shrink-0 text-white text-xs font-bold mt-0.5"
                  style={{ backgroundColor: activeProject === i ? accentColor : '#9CA3AF' }}
                >
                  {String(i + 1).padStart(2, '0')}
                </div>
                <div>
                  <div className="text-gray-900 font-semibold text-sm mb-1 leading-snug">{p.title}</div>
                  <div className="text-gray-400 text-xs">{p.industry}</div>
                </div>
              </div>
            </button>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PartnerReferenzen;
